module.exports = __webpack_public_path__ + "img/5.5ce2591c.png";